function countUp(element, endValue, prefix = '', suffix = '', duration = 200) {
    let startValue = 0;
    const increment = endValue / (duration / 16);
    const updateCounter = () => {
        startValue += increment;
        if (startValue < endValue) {
            element.textContent = prefix + Math.round(startValue).toLocaleString() + suffix;
            requestAnimationFrame(updateCounter);
        } else {
            element.textContent = prefix + Math.round(endValue).toLocaleString() + suffix;
        }
    };
    requestAnimationFrame(updateCounter);
}

function calculateYardage() {
    // Fetch values
    const wall1 = parseFloat(document.getElementById('wall1').value) || 0;
    const wall2 = parseFloat(document.getElementById('wall2').value) || 0;
    const wall3 = parseFloat(document.getElementById('wall3').value) || 0;
    const wall4 = parseFloat(document.getElementById('wall4').value) || 0;
    const height = parseFloat(document.getElementById('height').value) || 0;

    // Calculate total width and area
    const totalWidth = wall1 + wall2 + wall3 + wall4;
    const wallArea = (totalWidth / 36) * (height / 36);
    const linealYards = Math.round((wallArea / 0.75) * 1.3);

    // Retrieve price per yard and calculate the total price
    const container = document.querySelector('.calculator-container');
    const pricePerYard = parseFloat(container.getAttribute('data-price-per-yard')) || 70;
    const retailPrice = linealYards * pricePerYard;

    // Apply the count-up animation
    countUp(document.getElementById('estimate'), linealYards);
    countUp(document.getElementById('price'), Math.round(retailPrice), '$');
}